<template lang="pug">
.expenses-wrapper
  .expenses-wrapper__loader(v-if="loading")
    q-spinner(color="primary", size="3em")
  candle-chart(v-else, :chartData="chartData")
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from "vue";
import candleChart from "../../../shared/charts/candle/candleChart";
import { backend } from "@/api";
import { useEmitter } from "@/services/useEmitter";
import { generateFiltersParams } from "@/services/generateFiltersParams";
import { useStore } from "@/store";
import { handleError } from "@/services/handleErrors";

import { currentLocale } from "@/services/useLocales";

import i18n from "@/plugins/vue-i18n";

const emitter = useEmitter();

const store = useStore();

const props = defineProps({
  type: { type: String, required: true },
});

const loading = ref(true);
const chartData = ref({});

const getMonth = month => {
  return i18n["messages"][currentLocale.value]["date"]["monthsShort"][month];
};

const generateParams = () => {
  let localQuery = "";
  let localFilters = {};

  let localGrid = store.state.grid["expensesDashboard"];

  if (localGrid) {
    localQuery = localGrid.query || "";
    localFilters = localGrid.filters ? generateFiltersParams(localGrid.filters) : {};
  }

  const params = {
    query: localQuery,
    filters: localFilters,
    type: props.type,
  };

  return params;
};

const getData = async () => {
  const params = generateParams();
  loading.value = true;

  try {
    const { data } = await backend.index("api/v3/expenses_dashboard/charts", { params }, { encodeNestedData: true });
    chartData.value["legend"] = data.legend;
    chartData.value["total"] = data.total;
    chartData.value["data"] = data.data.map(item => {
      item.x = getMonth(new Date(item.x).getMonth());
      return item;
    });
  } catch (e) {
    handleError(e);
  } finally {
    loading.value = false;
  }
};

onMounted(async () => {
  await getData();

  emitter.on("refresh-expenses-dashboard-data", getData);
});

onBeforeUnmount(() => {
  emitter.off("refresh-expenses-dashboard-data");
});
</script>

<style lang="scss" scoped>
.expenses-wrapper {
  width: 100%;

  &__loader {
    width: 100%;
    min-height: 365px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
